import { useCallback, useState } from 'react';
import BZAPIService from '../../../services/BZAPIService';

/**
 * Applies a component override.
 *
 * Returns null on failure rather than throwing, so the caller can leave the
 * switch exactly where it was. There is no optimistic flip: a toggle that
 * silently disagrees with the server is worse than a slow one.
 */
export default function useComponentOverride() {
  const [saving, setSaving] = useState(false);
  const [toggleError, setToggleError] = useState(null);

  // A failed toggle belongs to the project it happened on — the caller must
  // clear it when leaving that project, or the alert survives into whatever
  // project is opened next (STRY0038263 final-review finding 3).
  const clearToggleError = useCallback(() => setToggleError(null), []);

  const applyToggle = useCallback(async (projectId, component, enabled) => {
    setSaving(true);
    setToggleError(null);
    try {
      const updated = await BZAPIService.bsaInvSetComponentOverride(projectId, component, enabled);
      setSaving(false);
      return (updated && updated.componentOverrides) || {};
    } catch (e) {
      setSaving(false);
      setToggleError('Could not update the component. Please try again.');
      return null;
    }
  }, []);

  return { saving, toggleError, applyToggle, clearToggleError };
}
